import React from 'react'

export const UploadVideo = () => (
  <svg width="107" height="83" viewBox="0 0 107 83" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="93" height="60" fill="#FFBF8E" />
    <rect x="14.5" y="23.5" width="92" height="59" fill="white" stroke="#767676" />
    <path d="M75 53L54 65.1244V40.8756L75 53Z" fill="#FFBF8E" />
  </svg>
)
